import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { PaginatedResponse, Club } from '@repo/types';
import { getAccessToken } from '@data/utils/getAccessToken';

type QueryOptions = {
  variables?: Partial<{
    name: string;
    page: number;
    limit: number;
    competitionId?: string;
  }>;
  enabled?: boolean;
};

export const useEditableClubsQuery = (options?: QueryOptions) => {
  const { variables, ...queryOptions } = options ?? {};
  return useQuery({
    queryKey: ['editable-clubs', variables],
    queryFn: fetchEditableClubs,
    ...(queryOptions ?? {}),
  });
};

const fetchEditableClubs: QueryFunction<PaginatedResponse<Club>, [string, QueryOptions['variables']]> = async ({
  queryKey,
}) => {
  const accessToken = getAccessToken();
  if (!accessToken) {
    const [, variables] = queryKey;
    const { data } = await axios.get<PaginatedResponse<Club>>(API.endpoints.editableClubs, {
      params: variables ?? {},
    });
    return data;
  }

  const [, variables] = queryKey;
  const { data } = await axios.get<PaginatedResponse<Club>>(API.endpoints.editableClubs, {
    params: variables ?? {},
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return data;
};
